import styled from 'styled-components';
import Dropdown from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import {
  space,
  color,
  layout,
  border,
  width,
  height,
  display,
  opacity,
  fontSize,
  maxWidth,
  alignSelf,
  textAlign,
  alignItems,
  lineHeight,
  fontWeight,
  typography,
  fontFamily,
  background,
  borderColor,
  buttonStyle,
  borderRadius,
  justifyContent,
} from 'styled-system';
//////////////////////////////////////////////////

const Text = styled.div`
  ${space}
  ${color}
  ${layout}
  ${border}
  ${typography}

  cursor: ${({ cursor }) => cursor};
  word-break: ${({ wordBreak }) => wordBreak || 'unset'};
  white-space: ${({ whiteSpace }) => whiteSpace || 'nowrap'};
  text-decoration: ${({ textDecoration }) => textDecoration};
  text-transform: ${({ textTransform }) => textTransform || 'unset'};
  text-overflow: ${({ withEllipsis }) => (withEllipsis ? 'ellipsis' : 'clip')}
`;

const InstanceButton = styled.button`
  ${space}
  ${width}
  ${color}
  ${height}
  ${border}
  ${display}
  ${fontSize}
  ${maxWidth}
  ${alignSelf}
  ${textAlign}
  ${alignItems}
  ${lineHeight}
  ${fontWeight}
  ${background}
  ${borderColor}
  ${borderRadius}
  ${justifyContent}

  cursor: ${({ cursor }) => cursor || 'pointer'};
  text-transform: ${({ textTransform }) => textTransform};
  text-decoration: ${({ textDecoration }) => textDecoration};
  transition: ${({ transition }) => transition || 'all 0.2s linear'};
`;

const Button = styled(InstanceButton)(buttonStyle);

Text.defaultProps = {
  minWidth: 'unset',
  maxWidth: 'unset',
  display: 'inline',
  overflow: 'hidden',
  fontWeight: 'unset',
};

const TextLink = styled(Text)`
  cursor: pointer;

  color: ${({ theme }) => theme.colors.linkColor};
`;

const StyledLink = styled.a`
  ${color}
  ${space}
  ${opacity}
  ${fontSize}
  ${maxWidth}
  ${textAlign}
  ${lineHeight}
  ${fontFamily}
  ${fontWeight}
  ${borderRadius}

  cursor: pointer;
  color: ${({ theme }) => theme.colors.linkColor};
  text-transform: ${({ textTransform }) => textTransform};
  text-decoration: ${({ textDecoration }) => textDecoration};

  &:hover {
    text-decoration: underline;
    color: ${({ hoveredColor }) => hoveredColor};
  }
`;

export {
  Text,
  Button,
  TextLink,
  Dropdown,
  TextField,
  StyledLink,
};
